import { BackendApiInstance } from "../config/Interceptor";
import Api from "./../config/Api";
export function sellerLogin(payload) {
  return BackendApiInstance.post(`${Api.sellerLogin}`, payload);
}
